<template>
  <div class="ThreeD">

<!--    <HomeHeader class="ThreeDHeader"/>-->

    <HomeHeader
      class="ThreeDHeader"
      :picList="picList"
      :festivalList="festivalList"
      :solarTermsList="solarTermsList"
      :recommendList="recommendList2"

      :threeDCategoryList="threeDCategoryList"
      :threeDRecommendList="threeDRecommendList"
      :festivalData="festivalData"
      :styleCategoryList="styleCategoryList"
      :styleRecommendList="styleRecommendList"
    />


<!--    <HomeHeaderFixed/>-->

    <no-ssr>
      <HomeHeaderFixed
        :picList="picList"
        :festivalList="festivalList"
        :solarTermsList="solarTermsList"
        :recommendList="recommendList2"

        :threeDCategoryList="threeDCategoryList"
        :threeDRecommendList="threeDRecommendList"
        :festivalData="festivalData"
        :styleCategoryList="styleCategoryList"
        :styleRecommendList="styleRecommendList"

      />
    </no-ssr>

    <DBackaground/>
    <DIntro/>

    <!--    <DModel />-->

    <DRecommend
      :hot-list="hotList"
      :topic-list="topicList"
    />
    <DList
      :list="list"
      @classifyHover="classifyHover"
    />
    <DDesign/>
    <DMaterial/>
    <div class="Gradient">
      <DUse/>
      <DMessage/>
    </div>
  </div>
</template>

<script>
import HomeHeader from '@/components/home/home-header/home-header'
import HomeHeaderFixed from '@/components/home/home-header/home-header-fixed'
import DBackaground from '@/components/3d/d-bg'
import DIntro from '@/components/3d/d-intro'
import DRecommend from '@/components/3d/d-recommend'
import DList from '@/components/3d/d-list'
import DDesign from '@/components/3d/d-design';
import DMaterial from '@/components/3d/d-material';
import DUse from '@/components/3d/d-use';
import DMessage from '@/components/3d/d-message';
import DModel from '@/components/3d/d-model';
import {parseListUrl} from "@/components/list/module";
import {listGetNextDate, listObjToArray, setListType} from "@/components/tupian/common/list";
import {fnBrowser, fnLayout, fnThreeD} from "@/fn";
import {THREE_D} from "@/constant/3d/3D";
import {getThreeDClassifyList, getThreeDClassifyPicList, getThreeDRecommend} from "@/api/three-d";
import {getDropDownByAll} from "~/api/home";

export default {
  name: "ThreeD",
  layout: 'home',
  components: {
    HomeHeader,
    HomeHeaderFixed,
    DBackaground,
    DIntro,
    DRecommend,
    DList,
    DDesign,
    DMaterial,
    DUse,
    DMessage,
    DModel
  },
  head() {
    return {
      title: '3D图片素材_3D海报模板免费下载-潮国创意',
      meta: [{
        hid: 'keywords',
        name: 'keywords',
        content: '3D图片,3D素材,3D海报、3D模板'
      }, {
        hid: 'description',
        name: 'description',
        content: '潮国创意精选高质量的3D图片素材、3D海报模板、3D人物图片模板素材供大家下载使用,下载版权潮流图片就到潮国创意。'
      }]
    };
  },
  async asyncData({app}) {
    let UA = app.context.req.headers['user-agent']
    let [
      recommendData,
      listData,

      hotData,
      threeDRes,
      festivalRes,
      styleRes,
    ] = await Promise.all([
      app.$api.getThreeDRecommend(),
      app.$api.getThreeDClassifyList(),

      /*app.$api.getDropdownByHot(),
      app.$api.getDropdownByThreeD(),
      app.$api.getDropdownByFestival(),
      app.$api.getDropdownByDesignStyle(),*/
    ])


   /* let {pic, marketing_festival, twenty_festival, content=[]} = hotData.data;
    let arr = [];
    for (let i = 0; i < content.length; i += 5) {
      arr.push(content.slice(i, i + 5));
    }*/

    return {
      list: fnThreeD.disposeList(listData.data),
      hotList: recommendData.data.hot,
      topicList: recommendData.data.failarmy,
      isSpider: fnBrowser.isSpider(UA),

      /*picList: pic.length > 5 ? pic.slice(0, 5) : pic,
      festivalList: marketing_festival.length > 5 ? marketing_festival.slice(0, 5) : marketing_festival,
      solarTermsList: twenty_festival.length > 5 ? twenty_festival.slice(0, 5) : twenty_festival,
      recommendList2: arr,
      threeDCategoryList: threeDRes.data.category,
      threeDRecommendList: threeDRes.data.recommend,
      festivalData: festivalRes.data,
      styleCategoryList: styleRes.data.design,
      styleRecommendList: styleRes.data.recommendPic,*/
    }
  },
  data() {
    return {
      list: [],
      hotList: [],
      topicList: [],
      isSpider: false,
      picList: [],
      festivalList: [],
      solarTermsList: [],
      recommendList2: [],
      threeDCategoryList: [],
      threeDRecommendList: [],
      festivalData: {},
      styleCategoryList: {},
      styleRecommendList: {},
    }
  },
  mounted() {
    // this.init();
    this.getDropDownByALL();
  },
  methods: {
    init() {
      this.getThreeDRecommend();
      this.getThreeDClassifyList();

    },
    getDropDownByALL(){
      getDropDownByAll().then(res =>{
        console.log(res)
        const { status , data } = res.data;
        if(status == 1){
          this.$store.commit('_Public/Header/setDropDownDataByAll',data)
        }
      })

    },
    async classifyHover(vo) {
      let {data} = await getThreeDClassifyPicList({
        module: vo.pid,
        category: vo.id
      });
      this.list.forEach(item => {
        if (vo.pid == item.id) {
          item.childs.forEach((j) => {
            if (j.id == vo.id) {
              item.pictures = data.data;
              item.classifyId = vo.id
            }
          })
        }
      })
    },

    async getThreeDRecommend() {
      let {data} = await getThreeDRecommend();
      let {failarmy, hot} = data.data;
      this.hotList = hot;
      this.topicList = failarmy
    },

    async getThreeDClassifyList() {
      let {data} = await getThreeDClassifyList();
      this.list = fnThreeD.disposeList(data.data);
    },
  }

}
</script>

<style lang="scss" scoped>
.ThreeD {
  background: #EDFFFC;

  .ThreeDHeader {
    margin-bottom: 41px;

    /deep/ .Header {
      padding: 32px 0 33px;

      .topbar-inner {

        .icon-logo {
          color: #000000 !important;
        }

        /* 菜单 */
        .menu-list {
          .menu-item {
            > a {
              color: #000000;
              @include ElementHover($color-primary, '');
            }
          }
        }

        .icon_collect-website {
          @include BgImage(297px, 49px, 'header/icon_collect-website@blue.png?v=1');
        }

        .copyright-box,
        .text-nologin,
        .CompanyLicense-title,
        .contribute-box {
          color: #000000;
          @include ElementHover($color-primary, '') {
            .icon_copyright {
              color: $color-primary;
            }
          }

        }

        .text-login {
          background-color: $color-primary;
          color: #FFFFFF;
          @include ElementHover(rgba(255, 255, 255, 0.9), rgba(105, 105, 255, 0.9));

        }


        > .search-box {
          //width: 240px;
          //height: 44px;
          //background: #ECEFF6;
          border-radius: 12px;
          border-color: transparent;

          .search-text {
            color: #000000;
            //background: #ECEFF6;
            background-color: #fff;
            border: 1px solid #E0E3E9;
            box-sizing: border-box;

            &::placeholder {
              color: rgba(0, 16, 19, 0.3) !important;
            }

            &:focus {
              background-color: #FFFFFF;
              border-color: $color-primary;
              color: #001013;
            }
          }

          .icon_search-box {
            width: 48px;
            border-radius: 12px;
            cursor: pointer;

            .icon-chaxun2 {
              color: #000000;
            }


            &:hover {
              background-color: $color-primary;

              .icon-chaxun2 {
                color: #FFFFFF;
              }
            }
          }
        }
      }
    }
  }

  .Gradient {
    width: 100%;
    height: 1503px;
    background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 51%, #F5F6FA 100%);
  }
}
</style>
